function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, `12506A7C-22F0-483A-91FD-075B25DF0F50`);

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, `Created with sketchtool.`);

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Summary",
  transform: "translate(-21.000000, -535.000000)",
  fill: "#797979",
  fillRule: "nonzero",
  stroke: "#797979",
  strokeWidth: 0.2
}, React.createElement("g", {
  id: "Group-15",
  transform: "translate(-1.000000, 0.000000)"
}, React.createElement("g", {
  id: "All_Posts",
  transform: "translate(23.000000, 536.000000)"
}, React.createElement("path", {
  className: "stroke",
  d: "M5.46,9.74803846 C6.74982,9.74803846 7.79898,8.73923077 7.79898,7.49942308 C7.79898,6.25880769 6.74982,5.25 5.46,5.25 C4.17018,5.25 3.12102,6.25880769 3.12102,7.49901923 C3.12102,8.73923077 4.17018,9.74803846 5.46,9.74803846 Z M5.46,6.05769231 C6.28656,6.05769231 6.95898,6.70465385 6.95898,7.49901923 C6.95898,8.29338462 6.28656,8.94034615 5.46,8.94034615 C4.63344,8.94034615 3.96102,8.29378846 3.96102,7.49942308 C3.96102,6.70505769 4.63344,6.05769231 5.46,6.05769231 Z",
  id: "Shape"
}), React.createElement("path", {
  className: "stroke",
  d: "M0,0 L0,16.1538462 L0,21 L21,21 L21,16.1538462 L21,0 L0,0 Z M0.84,0.807692308 L20.16,0.807692308 L20.16,11.6012885 L15.82392,7.77928846 C15.7416,7.707 15.63324,7.67105769 15.52152,7.67348077 C15.41022,7.67832692 15.30522,7.72557692 15.23004,7.80473077 L11.11656,12.1367885 L9.1245,10.2213462 C8.96742,10.0707115 8.71626,10.0630385 8.54994,10.2035769 L1.52124,16.1538462 L0.84,16.1538462 L0.84,0.807692308 Z M20.16,20.1923077 L0.84,20.1923077 L0.84,16.9615385 L20.16,16.9615385 L20.16,20.1923077 Z M2.79258,16.1538462 L8.80866,11.0609423 L13.1355,15.2209615 C13.29972,15.3788654 13.56516,15.3788654 13.72938,15.2209615 C13.8936,15.0630577 13.8936,14.8078269 13.72938,14.6499231 L11.71044,12.7086346 L15.56646,8.64836538 L20.16,12.6969231 L20.16,16.1538462 L2.79258,16.1538462 Z",
  id: "Shape"
})))));

const SvgComponent = props => React.createElement("svg", _extends({
  width: "23px",
  height: "23px",
  viewBox: "0 0 23 23",
  version: 1.1,
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _ref, _ref2, _ref3);

export default __webpack_public_path__ + "static/media/icon-all-posts.d3b90fe5.svg";
export { SvgComponent as ReactComponent };